import React from 'react'
import categories from '../../categories';
import './css.css'

export default function Buttons(props) {
    return (
        <ul className={"buttons " + props.classButtons}>
            <li id='' className={props.category === '' ? 'li-menu active' : 'li-menu'} 
            onClick={props.onClick}>Todas</li>
            {categories && categories.map((c, index) => 
            <li key={index} 
            id={c.name}
            className={props.category === c.name ? 'li-menu active' : 'li-menu'} 
            onClick={props.onClick}
            >{c.value === "Pantalón" ? "Pantalones" : c.value + "s"}
            </li>
            )}
        </ul>
    )
}
